export const FETCH_NOTIFICATIONS_LOADING = 'FETCH_NOTIFICATIONS_LOADING';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_ERROR = 'FETCH_NOTIFICATIONS_ERROR';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
